import type { IModal } from '@bjb/bjb-web-components/src/components/jb-modal/jb-modal.custom';
import type { IContactOverlay } from '@bjb/bjb-web-components/src/components/jb-contact-overlay/jb-contact-overlay.custom';
import type { ILinkableClickEventDetail } from '@bjb/bjb-web-components/src/mixins';
import { JbContactOverlay } from '@bjb/bjb-web-components/dist/components/jb-contact-overlay/jb-contact-overlay.js';

type ContactOverlayDetails = {
  modal: IModal,
  contactOverlay: IContactOverlay,
}

document.body.addEventListener('jb-link:clicked', (event: CustomEvent<ContactOverlayDetails&ILinkableClickEventDetail>) => {
  if (!event.detail.contactOverlay) {
    return;
  }

  if (event.detail.clickEvent) {
    event.detail.clickEvent.preventDefault();
    event.detail.clickEvent.stopPropagation();
  }
  event.stopPropagation();

  const contactOverlayProps = {
    ...event.detail.contactOverlay,
  };

  const modalProps = {
    ...event.detail.modal,
    color: 'white',
    hasLogo: true,
    newAnimation: true,
    returnFocusTo: event.detail.linkTag,
  };
  JbContactOverlay.open(modalProps, contactOverlayProps).then();
});
